import { Component } from '@angular/core';
import { IconSize } from '@predictiveindex/tapestry';
import { englishLanguageLocale } from '../constants-types/constants';
import { TranslationService } from '../translations/Translation.service';

@Component({
    selector: 'help-link',
    host: {
        style: 'display:flex'
    },
    template: `
        @if (usePendoLink()) {
            <tapestry-icon [size]="iconSize" name="help_bold"> </tapestry-icon>
        } @else {
            <!--As of December 2020 everyone should receieve a Pendo Resource Center by default.
          The link is removed for now-->
            <i class="fa fa-question-circle" aria-hidden="true"></i>
        }
    `,
    standalone: false
})
export class HelpLinkComponent {
    iconSize = IconSize.Medium;

    constructor(public TR: TranslationService) {}

    usePendoLink() {
        return this.TR.currentLocale === englishLanguageLocale;
    }
}
